export const emailRegExp = new RegExp(
    /^[A-Z0-9._%+'-]+@(?:[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,}$/i
)

/**
 * A regex that checks a string to see if it follows the basic email format:
 * one or many characters, followed by an @, more characters, a period, and then a domain that's 2-4 characters
 *
 * @param email - string | undefined | unknown
 * @returns boolean
 */
export function validateEmailAddress(email?: string | undefined | unknown): boolean {
    if (typeof email != "string") {
        return false
    }

    return emailRegExp.test(email)
}

/**
 * normalizing an email is like normalizing two vectors - you end up with a unit email that is the same if it points in the same direction
 * for example, capitalization: Matt@hummingbirddrones.ca is the same as matt@hummingbirddrones.ca
 * the string returned can be stored in databases & compared against
 * @param email - string
 * @returns string that should be equivalent
 */
export function normalizeEmailAddress(email: string): string {
    return email.toLowerCase()
}

/**
 * masks the email secure enough we can output an indicator string in logs without worrying about
 * potential pii leaks
 *
 * @param email
 * @returns string | undefined
 */
export function maskEmailAddress(email?: string): string | undefined {
    if (!email || !validateEmailAddress(email)) {
        return undefined
    }

    return email.replace(/^(.{2})([^@]+)(.)@(.).+(.)$/, "$1***$3@$4***")
}
